<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iv"></a>
<p class="copyt">First published in Great Britain in 2020 by</p>
<p class="copy">Pen &amp; Sword Military</p>
<p class="copy">An imprint of</p>
<p class="copy">Pen &amp; Sword Books Ltd</p>
<p class="copy">Yorkshire – Philadelphia</p>
<p class="copy1">Copyright © Neil R Storey 2020</p>
<p class="copy1">ISBN 978 1 52677 294 7</p>
<p class="copy">eISBN 978 1 52677 295 4</p>
<p class="copy">Mobi ISBN 978 1 52677 296 1</p>
<p class="copy1">The right of Neil R Storey to be identified as Author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy1">A CIP catalogue record for this book is available from the British Library.</p>
<p class="copy1">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.</p>
<p class="copy1">Padstow, Cornwall.</p>
<p class="copy">Pen &amp; Sword Books Limited incorporates the imprints of Atlas, Archaeology, Aviation, Discovery, Family History, Fiction, History, Maritime, Military, Military Classics, Politics, Select, Transport, True Crime, Air World, Frontline Publishing, Leo Cooper, Remember When, Seaforth Publishing, The Praetorian Press, Wharncliffe Local History, Wharncliffe Transport, Wharncliffe True Crime and White Owl.</p>
<p class="copy1">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy1">PEN &amp; SWORD BOOKS LIMITED</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
<p class="copy1">Or</p>
<p class="copy1">PEN AND SWORD BOOKS</p>
<p class="copy">1950 Lawrence Rd, Havertown, PA 19083, USA</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:Uspen-and-sword@casematepublishers.com"><span class="underline">Uspen-and-sword@casematepublishers.com</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.penandswordbooks.com" target="_blank"><span class="underline">www.penandswordbooks.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?1720200a